import React, { FC, memo } from 'react';
import Feather from 'react-native-vector-icons/Feather';

import dynamicSize from '@webtrader/core/dynamic-size';

import { IVectorIconProps } from './index';

Feather.loadFont();

type FeatherIconsName =
  | 'bell'
  | 'copy'
  | 'home'
  | 'plus'
  | 'lock'
  | 'clock'
  | 'minus'
  | 'repeat'
  | 'search'
  | 'trash-2'
  | 'settings'
  | 'x-circle'
  | 'file-text'
  | 'refresh-cw'
  | 'refresh-ccw'
  | 'arrow-left'
  | 'arrow-right'
  | 'bar-chart-2'
  | 'check-circle'
  | 'arrow-left-circle'
  | 'arrow-right-circle'
  | 'chevron-right'
  | 'chevron-left'
  | 'book-open'
  | 'chevron-up'
  | 'chevron-down'
  | 'upload'
  | 'server'
  | 'link';

const FeatherIcon: FC<IVectorIconProps<FeatherIconsName>> = (props) => {
  const { name, color, size = 20, ...restProps } = props;

  return <Feather {...restProps} name={name} color={color} size={dynamicSize.convertSize(size)} />;
};

export default memo(FeatherIcon);
